import React, { useState, useEffect, useRef, useCallback } from 'react';
import './CookiePolicy.css';

const IconWrapper = ({ children, size = 20, style, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: '10px', verticalAlign: 'middle', flexShrink: 0, ...style }}
    className={className}
    aria-hidden="true"
  >
    {children}
  </svg>
);

const ICONS = {
  COOKIE: (
    <IconWrapper>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 2a10 10 0 0 0-2 19.8" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <circle cx="15.5" cy="8.5" r="1.5" />
      <circle cx="10.5" cy="14.5" r="1.5" />
      <circle cx="15" cy="14" r="1" />
    </IconWrapper>
  ),
  CATEGORIES: (
    <IconWrapper>
      <rect x="3" y="3" width="7" height="7" />
      <rect x="14" y="3" width="7" height="7" />
      <rect x="14" y="14" width="7" height="7" />
      <rect x="3" y="14" width="7" height="7" />
    </IconWrapper>
  ),
  LOCK_CONFIDENTIAL: (
    <IconWrapper>
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </IconWrapper>
  ),
  ANALYTICS: (
    <IconWrapper>
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
    </IconWrapper>
  ),
  SETTINGS: (
    <IconWrapper>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </IconWrapper>
  ),
  ALERT: (
    <IconWrapper>
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </IconWrapper>
  ),
  SCALE: (
    <IconWrapper>
      <path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" />
      <path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" />
      <path d="M7 21h10" />
      <path d="M12 3v18" />
      <path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2" />
    </IconWrapper>
  ),
  CONTACT: (
    <IconWrapper>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </IconWrapper>
  ),
  ARROW_UP: (
    <IconWrapper size={20} style={{ marginRight: 0 }}>
      <line x1="12" y1="19" x2="12" y2="5" />
      <polyline points="5 12 12 5 19 12" />
    </IconWrapper>
  ),
  SEARCH: (
    <IconWrapper size={18} style={{ marginRight: '8px' }} className="cookie-policy-page-search-icon">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </IconWrapper>
  )
};

const officialAddress = "Mani Casadona, IT/ITES Business Hub, New Town, Rajarhat, Kolkata, West Bengal – 700161, India";
const officialPhone = "+91 90383 20103";
const officialEmail = "nutrivioheadoffice@gmail.com";
const lastUpdatedDate = "5 Jan 2026";

const rawSections = [
  {
    id: 'what-are-cookies',
    num: "01",
    title: 'What Are Cookies & Tracking Technologies?',
    icon: ICONS.COOKIE,
    content: `
      <p>Cookies are compact text files placed onto your computer, tablet, or mobile device when you visit websites. They are widely utilized by corporate and advisory platforms to ensure seamless navigation, improve page load performance, and maintain security across online sessions.</p>
      <p><strong>Nutrivio Medical Services Private Limited</strong> (&ldquo;Nutrivio&rdquo;, &ldquo;we&rdquo;, or &ldquo;our&rdquo;) utilizes cookies and related web tokens strictly to maintain secure institutional inquiry routing, prevent spam submissions, and evaluate technical website performance.</p>
      <p>This policy details the exact cookie types deployed on our portal, their operational purposes, and how you can exercise full control over your cookie preferences.</p>
    `
  },
  {
    id: 'categories-of-cookies',
    num: "02",
    title: 'Categories of Cookies We Deploy',
    icon: ICONS.CATEGORIES,
    content: `
      <p>We classify the cookies utilized on our institutional web portal into the following four distinct categories:</p>
      
      <div class="cookie-policy-page-table-wrapper">
        <table class="cookie-policy-page-table">
          <thead>
            <tr>
              <th>Cookie Category</th>
              <th>Operational Purpose</th>
              <th>Lifespan</th>
              <th>Classification</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Strictly Necessary</strong></td>
              <td>Essential for core platform functionality, CSRF security tokens, secure form routing, and session state retention.</td>
              <td>Session (Expires on browser close)</td>
              <td><span class="cookie-policy-page-tag required">Mandatory</span></td>
            </tr>
            <tr>
              <td><strong>Security & Anti-Abuse</strong></td>
              <td>Protects institutional inquiry portals and faculty registration channels against bot floods, malicious exploits, and spam submissions.</td>
              <td>Up to 30 Days</td>
              <td><span class="cookie-policy-page-tag required">Mandatory</span></td>
            </tr>
            <tr>
              <td><strong>Analytics & Performance</strong></td>
              <td>Collects aggregated, anonymous diagnostic metrics (e.g., Google Analytics) such as page loading speeds and bounce rates to optimize user experience.</td>
              <td>1 Day &ndash; 2 Years</td>
              <td><span class="cookie-policy-page-tag optional">Analytical</span></td>
            </tr>
            <tr>
              <td><strong>User Preferences</strong></td>
              <td>Remembers your interface selections such as search query states, table of contents position, and banner dismissals.</td>
              <td>Up to 1 Year</td>
              <td><span class="cookie-policy-page-tag optional">Functional</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    `
  },
  {
    id: 'confidentiality-guarantee',
    num: "03",
    title: 'Zero Tracking of Confidential Doctor / Institutional Data',
    icon: ICONS.LOCK_CONFIDENTIAL,
    content: `
      <div class="cookie-policy-page-callout-box">
        <p><strong>Strict Privacy Commitment:</strong> Cookies deployed by Nutrivio <strong>never extract, store, or profile confidential faculty documents, uploaded CV files, NMC registration credentials, promoter phone numbers, or institutional financial information</strong>.</p>
      </div>
      <p>All sensitive information submitted through our <em>For Institutions</em> or <em>For Medical Faculty</em> forms is processed exclusively through isolated, encrypted server endpoints and is never correlated with behavioral cookie trackers or advertising data brokers.</p>
    `
  },
  {
    id: 'third-party-analytics',
    num: "04",
    title: 'Third-Party Analytics & Web Metrics',
    icon: ICONS.ANALYTICS,
    content: `
      <p>To evaluate the reach and technical efficiency of our medical education advisory resources, we may integrate standard web analytical services such as <strong>Google Analytics</strong> and <strong>Google Search Console</strong>.</p>
      <ul>
        <li><strong>Aggregated Data Only:</strong> Analytics services process anonymized IP addresses, browser engine versions, and time spent on specific institutional guidance pages.</li>
        <li><strong>No Commercial Data Resale:</strong> Analytics telemetry is utilized strictly for internal performance auditing and infrastructure optimization.</li>
        <li><strong>Opt-Out Availability:</strong> You may prevent Google Analytics data collection by installing the official <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" class="cookie-policy-page-link">Google Analytics Opt-Out Browser Add-On</a>.</li>
      </ul>
    `
  },
  {
    id: 'browser-management-guide',
    num: "05",
    title: 'How to Control, Block & Delete Cookies',
    icon: ICONS.SETTINGS,
    content: `
      <p>You maintain full autonomy to accept, restrict, or purge cookies through your browser settings. Below are direct configuration links for major desktop and mobile web browsers:</p>

      <div class="cookie-policy-page-browser-grid">
        <div class="cookie-policy-page-browser-card">
          <h6>Google Chrome</h6>
          <p>Settings &gt; Privacy and security &gt; Third-party cookies &gt; Clear browsing data.</p>
        </div>
        <div class="cookies-policy-page-browser-card">
          <h6>Apple Safari (iOS / macOS)</h6>
          <p>Preferences / Settings &gt; Privacy &gt; Block all cookies / Manage Website Data.</p>
        </div>
        <div class="cookie-policy-page-browser-card">
          <h6>Mozilla Firefox</h6>
          <p>Settings &gt; Privacy &amp; Security &gt; Cookies and Site Data &gt; Clear Data.</p>
        </div>
        <div class="cookie-policy-page-browser-card">
          <h6>Microsoft Edge</h6>
          <p>Settings &gt; Cookies and site permissions &gt; Manage and delete cookies and site data.</p>
        </div>
      </div>
      <p class="cookie-policy-page-note"><em>Note: For other mobile or enterprise browsers, please consult your browser vendor's official support documentation.</em></p>
    `
  },
  {
    id: 'impact-of-disabling-cookies',
    num: "06",
    title: 'Impact of Disabling Cookies',
    icon: ICONS.ALERT,
    content: `
      <p>If you configure your browser to block all cookies (including essential session tokens), you can still review all public information on our website. However:</p>
      <ul>
        <li>Interactive enquiry forms may require manual token refresh to ensure anti-spam validation.</li>
        <li>Custom navigation states (such as active Table of Contents filters and sidebar toggle preferences) will reset upon reloading.</li>
      </ul>
    `
  },
  {
    id: 'regulatory-adherence',
    num: "07",
    title: 'Regulatory & Statutory Adherence',
    icon: ICONS.SCALE,
    content: `
      <p>Nutrivio Medical Services Private Limited adheres to statutory digital governance principles established under the <strong>Digital Personal Data Protection Act (DPDPA), 2023</strong>, the <strong>Information Technology Act, 2000</strong>, and applicable IT (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules.</p>
      <p>We ensure that all web processing activities operate with explicit user consent, minimal data footprint, and enterprise-grade transmission security.</p>
    `
  },
  {
    id: 'contact-info',
    num: "08",
    title: 'Data Governance Desk & Inquiries',
    icon: ICONS.CONTACT,
    content: `
      <p>If you have questions regarding our cookie practices, technical analytics, or digital privacy standards, please reach out to our corporate desk:</p>
      <p><strong>NUTRIVIO MEDICAL SERVICES PRIVATE LIMITED</strong></p>
      <address class="cookie-policy-page-address">
        <strong>Head Office:</strong><br>
        ${officialAddress}
      </address>
      <p><strong>Phone:</strong> <a href="tel:+919038320103" class="cookie-policy-page-link">${officialPhone}</a></p>
      <p><strong>WhatsApp Desk:</strong> <a href="https://wa.me/919038320103" target="_blank" rel="noopener noreferrer" class="cookie-policy-page-link">${officialPhone}</a></p>
      <p><strong>Official Email:</strong> <a href="mailto:${officialEmail}" class="cookie-policy-page-link">${officialEmail}</a></p>
      <hr class="cookie-policy-page-divider" />
      <p class="cookie-policy-page-meta-date"><em>Last Updated: <strong>${lastUpdatedDate}</strong>. Copyright &copy; 2026 Nutrivio Medical Services Private Limited. All Rights Reserved.</em></p>
    `
  }
];

const SECTIONS_DATA = rawSections.map(s => ({
  ...s,
  id: `cookie-policy-${s.id}`
}));

const CookiePolicy = () => {
  const [openSections, setOpenSections] = useState([]);
  const [activeTocId, setActiveTocId] = useState(null);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileSelectedId, setMobileSelectedId] = useState('all');
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const sectionRefs = useRef({});
  const mobileNavRef = useRef(null);

  SECTIONS_DATA.forEach(section => {
    if (!sectionRefs.current[section.id]) {
      sectionRefs.current[section.id] = React.createRef();
    }
  });

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 160;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
    }
  };

  const toggleSection = (id) => {
    setOpenSections(prev =>
      prev.includes(id) ? prev.filter(sid => sid !== id) : [...prev, id]
    );
  };

  const handleTocClick = (id) => {
    if (!openSections.includes(id)) {
      setOpenSections(prev => [...prev, id]);
    }
    setActiveTocId(id);
    scrollToSection(id);
  };

  const handleMobileSelect = (id) => {
    setMobileSelectedId(id);
    setActiveTocId(id === 'all' ? SECTIONS_DATA[0].id : id);

    if (id === 'all') {
      setOpenSections(SECTIONS_DATA.map(s => s.id));
      scrollToSection(SECTIONS_DATA[0].id);
    } else {
      setOpenSections([id]);
      scrollToSection(id);
    }
    setIsMobileNavOpen(false);
  };

  const handleScroll = useCallback(() => {
    setShowBackToTop(window.scrollY > 350);

    let currentActiveId = null;
    const headerOffset = 170;

    const sectionsInView = SECTIONS_DATA.filter(s =>
      s.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    for (let i = sectionsInView.length - 1; i >= 0; i--) {
      const section = sectionsInView[i];
      const element = document.getElementById(section.id);
      if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.top <= headerOffset) {
          currentActiveId = section.id;
          break;
        }
      }
    }

    if (currentActiveId) {
      setActiveTocId(currentActiveId);
    }
  }, [searchTerm]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    if (SECTIONS_DATA.length > 0) {
      setOpenSections(SECTIONS_DATA.map(s => s.id));
      setActiveTocId(SECTIONS_DATA[0].id);
    }

    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const filteredSections = SECTIONS_DATA.filter(s =>
    s.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sectionsToRender = (mobileSelectedId !== 'all')
    ? filteredSections.filter(s => s.id === mobileSelectedId)
    : filteredSections;

  return (
    <div className="cookie-policy-page-wrapper">
      
      {/* Sticky Subheader & Breadcrumbs */}
      <div className="cookie-policy-page-subheader">
        <div className="cookie-policy-page-subheader-inner">
          <nav aria-label="Breadcrumb" className="cookie-policy-page-breadcrumbs">
            <ol>
              <li><a href="/">Home</a></li>
              <li><span className="cookie-policy-page-sep">›</span><span aria-current="page">Cookie Policy</span></li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Main Layout */}
      <div className="cookie-policy-page-container">
        <div className="cookie-policy-page-layout">
          
          {/* ================= LEFT SIDEBAR ================= */}
          <aside className="cookie-policy-page-sidebar">
            <div className="cookie-policy-page-toc-card">
              
              {/* Search Box */}
              <div className="cookie-policy-page-search-box">
                <div className="cookie-policy-page-search-wrap">
                  {ICONS.SEARCH}
                  <input
                    type="search"
                    placeholder="Search cookie policy..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="cookie-policy-page-search-input"
                    aria-label="Filter cookie policy sections"
                  />
                </div>
              </div>

              {/* Mobile Selector Dropdown */}
              <div className="cookie-policy-page-mobile-dropdown" ref={mobileNavRef}>
                <button
                  type="button"
                  className="cookie-policy-page-mobile-toggle-btn"
                  onClick={() => setIsMobileNavOpen(!isMobileNavOpen)}
                >
                  <span>{mobileSelectedId === 'all' ? 'All Policy Sections' : filteredSections.find(s => s.id === mobileSelectedId)?.title}</span>
                  <span className={`cookie-policy-page-select-arrow ${isMobileNavOpen ? 'open' : ''}`}>▼</span>
                </button>
                {isMobileNavOpen && (
                  <ul className="cookie-policy-page-mobile-listbox">
                    <li 
                      className={mobileSelectedId === 'all' ? 'active' : ''}
                      onClick={() => handleMobileSelect('all')}
                    >
                      All Policy Sections
                    </li>
                    {filteredSections.map(s => (
                      <li 
                        key={s.id}
                        className={mobileSelectedId === s.id ? 'active' : ''}
                        onClick={() => handleMobileSelect(s.id)}
                      >
                        {s.title}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* Desktop Table of Contents */}
              <nav className="cookie-policy-page-desktop-toc">
                <h3 className="cookie-policy-page-toc-heading">Policy Index</h3>
                <ul className="cookie-policy-page-toc-list">
                  {filteredSections.map(s => (
                    <li key={s.id} className={`cookie-policy-page-toc-item ${activeTocId === s.id ? 'active' : ''}`}>
                      <a
                        href={`#${s.id}`}
                        onClick={(e) => { e.preventDefault(); handleTocClick(s.id); }}
                        className="cookie-policy-page-toc-link"
                      >
                        <span className="cookie-policy-page-toc-num">{s.num}</span>
                        <span className="cookie-policy-page-toc-text">{s.title}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>

              {/* Sidebar Trust Seal Box */}
              <div className="cookie-policy-page-sidebar-trust-box">
                <div className="cookie-policy-page-trust-icon">
                  {ICONS.LOCK_CONFIDENTIAL}
                </div>
                <div>
                  <strong>No Doctor Profiling</strong>
                  <p>Cookies do not track doctor credentials, registration IDs, or CV files.</p>
                </div>
              </div>

            </div>
          </aside>

          {/* ================= MAIN CONTENT ================= */}
          <main className="cookie-policy-page-main-content">
            {sectionsToRender.length > 0 ? (
              sectionsToRender.map(section => {
                const isOpen = openSections.includes(section.id);
                return (
                  <div 
                    key={section.id} 
                    id={section.id} 
                    className="cookie-policy-page-card"
                    ref={sectionRefs.current[section.id]}
                  >
                    <button
                      type="button"
                      className="cookie-policy-page-card-header"
                      onClick={() => toggleSection(section.id)}
                      aria-expanded={isOpen}
                    >
                      <div className="cookie-policy-page-card-title-wrap">
                        <span className="cookie-policy-page-card-icon">{section.icon}</span>
                        <h2 className="cookie-policy-page-card-title">{section.title}</h2>
                      </div>
                      <span className={`cookie-policy-page-chevron ${isOpen ? 'open' : ''}`}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </button>

                    {isOpen && (
                      <div 
                        className="cookie-policy-page-card-body" 
                        dangerouslySetInnerHTML={{ __html: section.content }} 
                      />
                    )}
                  </div>
                );
              })
            ) : (
              <div className="cookie-policy-page-no-results">
                <h3>No Matching Sections</h3>
                <p>No cookie policy topics match "<strong>{searchTerm}</strong>". Please clear your search query.</p>
              </div>
            )}
          </main>

        </div>
      </div>

      {/* Floating Back to Top Button */}
      <button
        type="button"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className={`cookie-policy-page-back-to-top ${showBackToTop ? 'visible' : ''}`}
        aria-label="Back to top"
      >
        {ICONS.ARROW_UP}
      </button>

    </div>
  );
};

export default CookiePolicy;